import QRCode from "qrcode";

const PRINT_BODY_CLASS = "package-qr-printing";
const PRINT_STYLE_ID = "package-qr-print-page-style";

const injectPrintPageStyles = () => {
  if (document.getElementById(PRINT_STYLE_ID)) return;

  const style = document.createElement("style");
  style.id = PRINT_STYLE_ID;
  style.textContent = `
    @media print {
      @page {
        size: 100mm 100mm;
        margin: 0;
      }

      html.package-qr-printing,
      body.package-qr-printing {
        width: 100mm !important;
        height: auto !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: visible !important;
      }

      html.package-qr-printing #package-qr-print-sheet {
        display: block !important;
      }

      html.package-qr-printing .package-sticker-page {
        display: block !important;
        width: 100mm !important;
        height: 100mm !important;
        box-sizing: border-box;
        page-break-after: always;
        break-after: page;
        page-break-inside: avoid;
        break-inside: avoid;
      }

      html.package-qr-printing .package-sticker-page:last-child {
        page-break-after: auto;
        break-after: auto;
      }
    }
  `;
  document.head.appendChild(style);
};

const removePrintPageStyles = () => {
  document.getElementById(PRINT_STYLE_ID)?.remove();
};

export const PACKAGE_QR_PREFIX = "PK-";
export const PACKAGE_STICKER_FIRST_PAGE_PARTS = 12;
export const PACKAGE_STICKER_CONTINUATION_PARTS_PER_PAGE = 16;

export const chunkPackageStickerParts = (parts) => {
  const list = Array.isArray(parts) ? parts : [];

  if (list.length === 0) return [{ parts: [] }];

  const pages = [];
  let offset = 0;

  const firstPageParts = list.slice(0, PACKAGE_STICKER_FIRST_PAGE_PARTS);
  pages.push({ parts: firstPageParts });
  offset = firstPageParts.length;

  while (offset < list.length) {
    const pageParts = list.slice(
      offset,
      offset + PACKAGE_STICKER_CONTINUATION_PARTS_PER_PAGE
    );
    pages.push({ parts: pageParts });
    offset += pageParts.length;
  }

  return pages;
};

export const packageQrText = (label, id) =>
  `${PACKAGE_QR_PREFIX}${label}/${id}`;

export const parsePackageScan = (text) => {
  const trimmed = String(text ?? "").trim();
  if (!trimmed.startsWith(PACKAGE_QR_PREFIX)) return null;

  const body = trimmed.slice(PACKAGE_QR_PREFIX.length);
  const slashIndex = body.lastIndexOf("/");
  if (slashIndex === -1) return null;

  const packageLabel = body.slice(0, slashIndex).trim();
  const packageId = body.slice(slashIndex + 1).trim();
  if (!packageLabel || !/^\d+$/.test(packageId)) return null;

  return { packageLabel, packageId };
};

export const printPackageStickerLabel = async ({
  label,
  id,
  packageNo,
  projectOrderIdentifier,
  parts,
  onReady,
  onDone,
}) => {
  const text = packageQrText(label, id);
  const dataUrl = await QRCode.toDataURL(text, { width: 128, margin: 1 });
  const itemCount = Array.isArray(parts) ? parts.length : 0;
  const pages = chunkPackageStickerParts(parts);

  onReady({
    dataUrl,
    projectOrderIdentifier,
    packageNo,
    itemCount,
    pages,
  });

  const cleanup = () => {
    document.documentElement.classList.remove(PRINT_BODY_CLASS);
    document.body.classList.remove(PRINT_BODY_CLASS);
    removePrintPageStyles();
    window.onafterprint = null;
    onDone();
  };

  window.onafterprint = cleanup;

  requestAnimationFrame(() => {
    injectPrintPageStyles();
    document.documentElement.classList.add(PRINT_BODY_CLASS);
    document.body.classList.add(PRINT_BODY_CLASS);
    requestAnimationFrame(() => {
      window.print();
    });
  });
};
